<template>
  <div class="express-vue-temp app-section-grey">
    <!-- <BtnMain v-if="isLoggedIn" @btnClicked="handleLogout" text="Logout" btnClass="logout-btn" variant="dark" /> -->
    <router-view />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
// import BtnMain from './components/BtnMain'
export default {
  name: "tf-vue-recruitment-app",
  components: {
    // BtnMain
  },
  computed: {
    ...mapGetters({
      isLoggedIn: 'authStore/isLoggedIn'
    })
  },
  methods: {
    ...mapActions({
      logoutAction: 'authStore/logoutAction'
    }),  
    async handleLogout () {
      await this.logoutAction()
    }
  }
};
</script>

<style lang="scss">
@import "assets/scss/index";
// Example CSS can be added here
@import "assets/css/example.css";
.express-vue-temp {
  padding: 0 10px;
}
.section-heading {
  text-align: center;
  color: #434343;
}
.section-heading::after {
  content: "";
  display: block;
  margin: 15px auto 0 auto;
  width: 30px;
  height: 1px;
  background-color: #ffa409;
}
.login {
  padding: 20px 0;
}
.login-card {
  padding: 40px 0;
}
.form-control.is-required {
  border-color: #ffa409 !important;
  background-image: none !important;
}
.alert {
  display: flex;
  justify-content: center;
  align-items: center;
}
.alert p {
  margin: 0;
}
.express-vue-temp a {
  color: #ffa409;
}
.express-vue-temp a:hover {
  color: #ffa409;
}
.highlight-text {
  color: #ffa409;
}
.mobile-text {
  display: block;
}
.desktop-text {
  display: none;
}
@media only screen and (min-width: 992px) {
  .login-card {
    padding: 40px 200px;
  }
  .express-vue-temp {
  padding: 0;
  .mobile-text {
    display: none;
  }
  .desktop-text {
    display: block;
  }
}
}
.col {
  background-color: transparent;
}
.form-control {
  // border: none !important;
  padding: 25px !important;
}
.custom-select {
  // border: none !important;
  height: 50px !important;
  padding: 0 25px !important;
}
.application textarea {
  height: 400px !important;
}
</style>
